import { render, staticRenderFns } from "./GoodsHead.vue?vue&type=template&id=7288448f&"
import script from "./GoodsHead.vue?vue&type=script&lang=js&"
export * from "./GoodsHead.vue?vue&type=script&lang=js&"
import style0 from "./GoodsHead.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports